<template>
  <div class="editReport" style="border:1px solid #e0e0e0;">
    <div class="titleForm-container">新增质检报告信息</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="90px" class="ruleForm">
          <el-form-item label="检测编号" prop="no">
            <el-input v-model="baseForm.no" size="medium" style="width:100%;" placeholder="请输入检测编号" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" maxlength="20">
            </el-input>
          </el-form-item>
          <el-form-item label="质检机构" prop="inspectionOrganizationName">
            <el-select v-model="baseForm.inspectionOrganizationName" placeholder="请选择" size="medium" style="width:100%;">
              <el-option v-for="item in organizationKeyValue" :key="item.id" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检测时间" prop="time">
            <el-date-picker type="datetime" placeholder="选择日期" :clearable="false" v-model="baseForm.time" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item label="质检员" prop="inspector">
            <el-input v-model="baseForm.inspector" size="medium" style="width:100%;" placeholder="请输入质检员" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item label="质检报告" prop="images">
            <el-upload
              style="width:1200px;"
              :action="uploadURl"
              :file-list="fileList"
              :class="{chide:hideUpload}"
              :on-change="handleChange"
              list-type="picture-card"
              :with-credentials="true"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove">
              <i class="el-icon-plus">
                <h4 class="upload-tip">最多上传四张jpg/png图片，且不超过500kb</h4>
              </i>
            </el-upload>
           
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item class="save-cancel" v-if="edit">
            <el-col :span="8">
              <el-button class="save-btn" @click="saveBase('baseForm')" :loading="loadingtype">保存</el-button>
            </el-col>
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('ruleForm')">取消</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
import mixins from "@/common/MixIn.js";
export default {
  name: "EditReport",
  mixins: [mixins],
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      defaultImg: [
        {
          name: "food.jpeg",
          url: require("../../../assets/images/qualityTracing/sample_jianyanbaogao2.png")
        }
      ],
      fileList: [],
      loadingtype: false,
      // 参数
      baseForm: {
        no: "",
        inspectionOrganizationName: "",
        inspector: "",
        images: [], //图片
        time: ""
      },
      organizationKeyValue: [], //机构下拉框列表
      // 校验规则
      rules: {
        no: [
          {
            required: true,
            message: "请先输入检测编号",
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            message: "检测编号格式不对,请重新输入"
          }
        ],
        inspectionOrganizationName: [
          {
            required: true,
            message: "请选择质检机构",
            trigger: "blur"
          }
        ],
        inspector: [
          {
            required: true,
            message: "请输入质检员",
            trigger: "blur"
          }
        ],
        images: [
          {
            required: true,
            message: "请上传质检报告",
            trigger: "blur"
          }
        ],
        time: [
          {
            required: true,
            message: "请选择检测时间",
            trigger: "blur"
          }
        ]
      },
      uploadURl: imgUpload.imgUpload // 文件上传地址
    };
  },
  async mounted() {
    await this.initPagePermission();
    if (this.baseForm.images.length == 0) {
      this.fileList = this.defaultImg;
    }
    this.getOrganizationData();
  },
  methods: {
    ...mapActions(modules.qualityCheck, [
      "getInspectionOrganizationKeyValue", //获取获取质检机构下拉框列表
      "getEditQualityCheckManage"
    ]),
    // 获取机构keyValue
    getOrganizationData() {
      this.getInspectionOrganizationKeyValue()
        .then(rsp => {
          this.organizationKeyValue = rsp;
        })
        .catch(err => {
          console.dir(err);
        });
    },
    async changeQUalityCheck(e, index) {
      this.getEditQualityCheckManage(e).then(async data => {
        this.qualityInspections[index].inspectionOrganizationId = data.id;
        this.qualityInspections[index].phone = data.phone;
        let imgs = [];
        data.images.map(item => {
          imgs.push(item.name);
        });
        this.qualityInspections[index].images = imgs;
        this.qualityInspections[index].address =
          data.fullAddress + data.address;
        this.qualityInspections[index].inspectionOrganizationName = data.name;
        let obj = {
          inspectionOrganizationId: this.qualityInspections[index]
            .inspectionOrganizationId,
          inspectionDate: this.qualityInspections[index].inspectionDate,
          phone: this.qualityInspections[index].phone,
          address: this.qualityInspections[index].address,
          // fullAddress: data.fullAddress + data.address,
          images: this.qualityInspections[index].images,
          inspectionOrganizationName: this.qualityInspections[index]
            .inspectionOrganizationName
        };
        this.$emit("getInspect", obj, index);
      });
    },
    judgeImgLength(fileList) {
      if (this.baseForm.images.length == 0) {
        this.fileList = this.defaultImg;
      } else {
        if (fileList.length != this.baseForm.images.length) {
          this.fileList = fileList.splice(1, 1);
        } else {
          this.fileList = fileList;
        }
      }
    },
    handleChange(file, fileLis) {
      if (fileLis.length >= 4) {
        this.hideUpload = true;
      } else {
        this.hideUpload = false;
      }
      console.log(this.hideUpload);
    },
    // 图片上传之前
    beforeUpload(file) {
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      // const isLt500KB = file.size / 1024 / 1024 < 0.5;
      if (!isImg) {
        this.$Alert.info({
          content: "上传图片只能是JPG/png格式!",
          duration: 3000,
          status: "error"
        });
        // this.$message.error("上传图片只能是JPG/png格式!");
        // return isImg && isLt500KB;
        return isImg;
      }
      // if (!isLt500KB) {
      //   this.$Alert.info({
      //     content: "上传图片大小不能超过500kb!",
      //     duration: 3000,
      //     status: "error"
      //   });
      //   // this.$message.error("上传图片大小不能超过500kb!");
      //   return isImg && isLt500KB;
      // }
      if (this.baseForm.images.length >= 4) {
        // this.$message({
        //   message: "最多上传四张图片",
        //   type: "success"
        // });
        this.$Alert.info({
          content: "最多上传四张图片",
          duration: 3000,
          status: "error"
        });
        return false;
      }
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      this.baseForm.images.push(res.name);
      this.judgeImgLength(fileList);
    },
    // 文件移除
    handleRemove(file, fileList) {
      if (file.id) {
        this.index = this.baseForm.images.indexOf(file.id);
      } else if (file.response) {
        this.index = this.baseForm.images.indexOf(file.response.name);
      } else {
        let urlSlashCount = file.url.split("/").length; // 统计有3斜杠
        let str = file.url.split("/")[urlSlashCount - 1].toLowerCase(); //获取数组最后一个
        this.index = this.baseForm.images.indexOf(str);
      }
      if (this.index != -1) {
        this.baseForm.images.splice(this.index, 1);
        this.judgeImgLength(fileList);
      }
      if (fileList.length >= 4) {
        this.hideUpload = true;
      } else {
        this.hideUpload = false;
      }
    },
    //保存
    async saveBase(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // 参数
          let obj = {
            reportNumber: this.baseForm.no,
            organizationId: this.baseForm.inspectionOrganizationName,
            inspector: this.baseForm.inspector,
            inspectionTime: this.baseForm.time,
            images: this.baseForm.images
          };
          console.log(obj);
          this.loadingtype = true;
          this.$api
            .addInspectionReport(obj)
            .then(data => {
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.loadingtype = false;
              this.$router.go(-1);
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
            });
        } else {
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="stylus" scoped>
.editReport >>> .el-upload-list--picture-card .el-upload-list__item {
  height: 220px;
}
.editReport >>> .el-upload--picture-card {
  height: 220px;
  .el-icon-plus {
    height: 220px;
  }
}
.save-btn,
.cancel-btn {
  margin-top:20px;
}
.upload-tip {
  position absolute
  top:150px;
  font-size:14px;
}
</style>
